module.exports = __webpack_public_path__ + "static/1-454db46a4f9663b2c863865ab34a8c14.png";